import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect } from "react";

const enum fields {
    liveChatUrl = "liveChatUrl",
}

interface Props extends WidgetProps {
    fields: {
        [fields.liveChatUrl]: string;
    };
}

const LiveChat: React.FC<Props> = ({ fields }) => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = fields.liveChatUrl;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return <><div id="MyLiveChatContainer"></div></>;
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.liveChatUrl,
            displayName: "My Live Chat Url",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the my live chat chat url",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: LiveChat,
    definition,
};

export default widgetModule;
